<template>
  <router-view />
  <Toast />
  <Transition name="route-loading">
    <div
      v-if="isRouteLoading"
      class="fixed inset-0 z-[9999998] flex items-center justify-center bg-white/60 backdrop-blur-sm"
    >
      <ProgressSpinner
        strokeWidth="3"
        class="h-16 w-16"
        :pt="{ circle: { style: 'stroke: #0ea5e9' } }"
      />
    </div>
  </Transition>
</template>
<style scoped>
.route-loading-enter-active,
.route-loading-leave-active {
  transition: opacity 0.2s ease;
}
.route-loading-enter-from,
.route-loading-leave-to {
  opacity: 0;
}
</style>
<script setup lang="ts">
import { isRouteLoading } from '@/composables/routeLoading'
import { enPrimeVueTranslations } from '@/locales/primeVue/en-primevue-translations'
import { esPrimeVueTranslations } from '@/locales/primeVue/es-primevue-translations'
import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { Toast, usePrimeVue } from 'primevue'
import ProgressSpinner from 'primevue/progressspinner'
import { onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { showUnauthenticatedToast, clearToastRef } from '@/composables/unauthenticatedToast'

import { useExportDataStore } from './stores/ExportDataStore'
import { useSignalRStore } from './stores/SignalRStore'

const exportDataStore = useExportDataStore()
const signalRStore = useSignalRStore()
const toast = useToast()
const primeVue = usePrimeVue()

const localePrimeVue = {
  pt: ptPrimeVueTranslations,
  es: esPrimeVueTranslations,
  en: enPrimeVueTranslations,
}

watch(showUnauthenticatedToast, (value) => {
  if (value) {
    toast.removeAllGroups()
    toast.add({
      severity: 'warn',
      summary: 'Não autenticado',
      detail: 'Você não está autenticado. Por favor, faça login novamente.',
      life: 7000,
    })
    clearToastRef()
  }
})

onMounted(() => {
  signalRStore.startConnection().then(() => {
    exportDataStore.setupHubConnection()
  })

  const languageLocale = localStorage.getItem('language')?.replaceAll('"', '')

  primeVue.config.locale =
    localePrimeVue[languageLocale as keyof typeof localePrimeVue] || localePrimeVue.pt
})
</script>

<style>
.p-toast {
  z-index: 99999999 !important;
}
</style>
